<div class="back-arrow-button d-flex align-items-center">
    <button type="button" (click)="buttonClick.emit()">
        <span class="back-arrow-button-icon d-flex justify-content-center align-items-center"
          inlineSVG="assets/image/arrow-outline.svg">
        </span>
    </button>
</div>
